export default __webpack_public_path__ + "static/media/bg_success.49240ade.jpg";